import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { GetBy, C } from '../_app/cuchillo/core/Element';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';
import { CSS } from '../_app/cuchillo/utils/CSS';

class ScrollItem__BlockBillboard extends ScrollItem__BlockDefault {
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);
    }

    resize(__w, __h) {
        super.resize(__w, __h);
    }
}

Scroll._registerClass('BlockBillboard', ScrollItem__BlockBillboard);

export default ScrollItem__BlockBillboard;
